export default __webpack_public_path__ + "static/media/Combi Packaging Systems.1bdaf687.png";